/**
 * The shippingType note_attribute in the Shopify Order
 */
export enum ShippingType {
    HD = 'hd',
    MPL_HA = 'mpl_ha',
    MPL_CS = 'mpl_cs',
    MPL_DELIVERY = 'mpl',
    MPL_MOL = 'mpl_mol',
    MPL_MEDIAMARKT = 'mpl_mediamarkt',
    MPL_COOP = 'mpl_coop',
    MPL_OFFICE = 'mpl_office',
    MPL_OTHER = 'mpl_other',
    FOXPOST = 'foxpost',
    GLS = 'gls',
    GLS_CS = 'gls_cs',
    GLS_HD = 'gls_hd',
    PACKETA = 'packeta',
    PACKETA_BOX = 'packeta_box',
    PACKETA_BRANCH = 'packeta_branch',
    FOXPOST_HD = 'foxpost_hd',
    FOXPOST_APM = 'foxpost_apm',
    FOXPOST_PACKETA_PP = 'foxpost_packeta_pp',
    FOXPOST_PACKETA_APM = 'foxpost_packeta_apm',
    DPD = 'dpd',
    DPD_PP = 'dpd_pp',
    DPD_HD = 'dpd_hd',
    SPRINTER = 'sprinter',
    FANCOURIER_OFFICE = 'fancourier_office',
    FANCOURIER_FANBOX = 'fancourier_fanbox',
    FANCOURIER_PAYPOINT = 'fancourier_paypoint',
    FANCOURIER_HD = 'fancourier_hd',
    FCI_PUDO_CZP = 'fci_pudo_czp',
    FCI_PUDO_FAN = 'fci_pudo_fan',
    FCI_PUDO_GLS = 'fci_pudo_gls',
    FCI_PUDO_HRP = 'fci_pudo_hrp',
    FCI_PUDO_INP = 'fci_pudo_inp',
    FCI_PUDO_LTP = 'fci_pudo_ltp',
    FCI_PUDO_MULTI = 'fci_pudo_multi',
    FCI_PUDO_PSL = 'fci_pudo_psl',
    FCI_PUDO_SLK = 'fci_pudo_slk',
    FCI_LOCKER_CZP = 'fci_locker_czp',
    FCI_LOCKER_FAN = 'fci_locker_fan',
    FCI_LOCKER_GLS = 'fci_locker_gls',
    FCI_LOCKER_HRP = 'fci_locker_hrp',
    FCI_LOCKER_INP = 'fci_locker_inp',
    FCI_LOCKER_LTP = 'fci_locker_ltp',
    FCI_LOCKER_MULTI = 'fci_locker_multi',
    FCI_LOCKER_PSL = 'fci_locker_psl',
    FCI_LOCKER_SLK = 'fci_locker_slk',
    FCI_OFFICE_CZP = 'fci_office_czp',
    FCI_OFFICE_FAN = 'fci_office_fan',
    FCI_OFFICE_GLS = 'fci_office_gls',
    FCI_OFFICE_HRP = 'fci_office_hrp',
    FCI_OFFICE_INP = 'fci_office_inp',
    FCI_OFFICE_LTP = 'fci_office_ltp',
    FCI_OFFICE_MULTI = 'fci_office_multi',
    FCI_OFFICE_PSL = 'fci_office_psl',
    FCI_OFFICE_SLK = 'fci_office_slk',

    SAMEDAY_HD = 'sameday_hd',
    SAMEDAY_OOH = 'sameday_ooh',
    SAMEDAY_LOCKER = 'sameday_locker',
    POSTASK_LOCKER = 'postask_locker',
    POSTASK_OFFICE = 'postask_office',
    INPOST_POP = 'inpost_pop',
    INPOST_PARCEL_LOCKER = 'inpost_parcel_locker',
    POSTNORD_BOX = 'postnord_box',
    POSTNORD_STAMP = 'postnord_stamp',
    POSTNORD_AGENT = 'postnord_agent',
    BRING_MANNED = 'bring_manned',
    BRING_UNMANNED = 'bring_unmanned',
    BRING_LOCKER = 'bring_locker',
    BPOST_POST_POINT = 'bpost_post_point',
    BPOST_LOCKER = 'bpost_locker',
    BPOST_POST_OFFICE = 'bpost_post_office',
    CORREOS_HOMEPAQ = 'correos_homepaq',
    OMNIVA_POST_OFFICE = 'omniva_post_office',
    OMNIVA_LOCKER = 'omniva_locker',

    CARGUS_SHOP = 'cargus_shop',
    CARGUS_LOCKER = 'cargus_locker',
    CARGUS_HD = 'cargus_hd',

    // Carriers offered through the Kvikk aggregator
    KVIKK_GLS = 'kvikk_gls',
    KVIKK_DPD = 'kvikk_dpd',
    KVIKK_PACKETA = 'kvikk_packeta',
    KVIKK_MPL = 'kvikk_mpl',
    KVIKK_GLS_HD = 'kvikk_gls_hd',
    KVIKK_DPD_HD = 'kvikk_dpd_hd',
    KVIKK_PACKETA_HD = 'kvikk_packeta_hd',
    KVIKK_MPL_HD = 'kvikk_mpl_hd',
    KVIKK_ALZABOX = 'kvikk_alzabox',
    KVIKK_PARCEL_SHOP = 'kvikk_parcel_shop',
    KVIKK_LOCKER = 'kvikk_locker',
    KVIKK_SHOP = 'kvikk_shop',
    KVIKK_FOXPOST = 'kvikk_foxpost',
    KVIKK_ZBOX = 'kvikk_zbox',
    KVIKK_ZPONT = 'kvikk_zpont',
    KVIKK_AUTOMATA = 'kvikk_automata',
    KVIKK_POSTA = 'kvikk_posta',
    KVIKK_POSTA_PONT = 'kvikk_posta_pont',

    HOME_DELIVERY = 'home_delivery',
}
